export default class CustomFormsService {
    constructor($http, appConfig) {
      "ngInject";
  
      this.$http = $http;
      this.appConfig = appConfig;
    }

    list(entityId) {
        return this.$http.get(this.appConfig.apiServiceBaseUri + `api/customforms/list/${entityId}`); 
    }    

    add(customForm) {
        return this.$http.post(this.appConfig.apiServiceBaseUri + `api/customforms/add/`, customForm); 
    }  
    
    edit(customForm) {
        return this.$http.post(this.appConfig.apiServiceBaseUri + `api/customforms/edit/`, customForm); 
    }  

    remove(entityId, customFormId) {
        return this.$http.get(this.appConfig.apiServiceBaseUri + `api/customforms/remove/${entityId}/${customFormId}`); 
    }            
  }


// WEBPACK FOOTER //
// ./client/app/common/services/customForms.service.js